import { render, staticRenderFns } from "./PdfThumbnail.vue?vue&type=template&id=11266c59&"
import script from "./PdfThumbnail.vue?vue&type=script&lang=ts&"
export * from "./PdfThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports